module.exports = __webpack_public_path__ + "static/media/stroller-cleaning-service-icon.03ff68e3.png";